module.exports = __webpack_public_path__ + "img/process-5.9ebfbcc3.png";